
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObcSequenceModal as ObcSequenceModalElement} from '@oicl/openbridge-webcomponents/dist/components/sequence-modal/sequence-modal.js';
 
 
 

 
 export const ObcSequenceModal = createComponent({
   react: React,
   tagName: 'obc-sequence-modal',
   elementClass: ObcSequenceModalElement,
   events: {
     
   }
  });
 
 